import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl1663ValidationSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    d50_id: yup.object().nullable().required(t("Το πεδίο είναι υποχρεωτικό")),

    aadeCertificateDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(
        new Date(1753, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1753"),
      )
      .max(
        new Date(),
        t("Η ημερομηνία δεν μπορεί να είναι μεταγενέστερη της σημερινής"),
      )
      .required(t("Το πεδίο είναι υποχρεωτικό")),

    fudocAadeCertificate: yup
      .string()
      .nullable()
      .required(t("Το πεδίο είναι υποχρεωτικό")),

    email: yup
      .string()
      .email(t("Το πεδίο πρέπει να είναι έγκυρη διεύθυνση email"))
      .max(100, t("Το πεδίο δεν μπορεί να υπερβαίνει τους 100 χαρακτήρες"))
      .required(t("Το πεδίο είναι υποχρεωτικό")),

    d02_code: yup.object().nullable().required(t("Το πεδίο είναι υποχρεωτικό")),

    chamberId: yup
      .object()
      .nullable()
      .required(t("Το πεδίο είναι υποχρεωτικό")),

    purpose: yup.string().nullable(),

    fudocLoipa: yup.string().nullable(),

    docLoipaFileDate: yup
      .date()
      .nullable()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(
        new Date(1753, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1753"),
      ),

    comments: yup
      .string()
      .nullable()
      .max(
        2000,
        t("Οι παρατηρήσεις δεν μπορούν να υπερβαίνουν τους 2000 χαρακτήρες"),
      ),
  });
};
